import { useTranslations } from 'next-intl';

export function ConsultationLanguagesNotice() {
  const t = useTranslations('ConsultationLanguagesNotice');

  return (
    <div className="flex min-h-[50px] w-full items-center justify-center overflow-hidden rounded-[10px] bg-[#f0f2f5] px-4 py-2 md:h-[50px] md:py-0">
      <p className="text-center text-[14px] font-normal leading-[20px] tracking-[-0.128px] text-[#575c66] md:text-[16px] md:leading-[17px]">
        <span>{t('title')}</span>{' '}
        <span className="whitespace-nowrap">{t('languages')}</span>
      </p>
    </div>
  );
}
